export default "/images/framework/Blackbg.1f81e320.svg?1f81e320";